if (!customElements.get('home-at-any-age-tabs')) {
  class HomeAtAnyAgeTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('.section-home-at-any-age__tab');
      this.panels = this.querySelectorAll('.section-home-at-any-age__panel');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
      });
    }

    handleTabClick(event) {
      const clickedTab = event.currentTarget;
      const targetPanelId = clickedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === clickedTab;
        tab.classList.toggle('section-home-at-any-age__tab--active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === targetPanelId;
        panel.classList.toggle('section-home-at-any-age__panel--active', isActive);
      });
    }
  }

  customElements.define('home-at-any-age-tabs', HomeAtAnyAgeTabs);
}
